var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("layout-3", {
        staticStyle: { "max-height": "30vh" },
        attrs: { id: _vm.pageid1, term: _vm.term, width: 6, height: 1 }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "overflow-y": "auto", "margin-bottom": "80px" } },
        [
          _vm.perms.includes("75")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Job Orders",
                  id: _vm.pageid2,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "1",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("74")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Invoices",
                  id: _vm.pageid3,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "73",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _vm.perms.includes("94")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Edit Number")
                    }
                  }
                },
                [_vm._v("Edit")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("72")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Edit")
                    }
                  }
                },
                [_vm._v("Edit PO Number Job Orders")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abbd6d6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abbd6d6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_PO_Numbers.vue
// module id = 554
// module chunks = 0